import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppointmentDataModal",
    {
      attrs: {
        title: _vm.isFirstStep ? "Кто будет пациентом?" : "Данные пациента",
        "has-close-icon": _vm.isFirstStep,
        "has-back-icon": !_vm.isFirstStep,
        "content-class": _vm.isMobile ? "" : null,
        persistent: _vm.isPersistentDialog,
        "has-divider": !_vm.isAnyTelemed,
        fullscreen: _vm.isMobile && !_vm.isFirstStep,
        disabled: _vm.isSavingProfile,
        eager: "",
      },
      on: { "appointment-data-modal:back": _vm.setFirstStep },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "div",
                { staticClass: "mb-4" },
                [
                  _c(
                    "AppointmentDataCard",
                    _vm._b(
                      {
                        ref: "patientCard",
                        staticClass: "px-2",
                        attrs: {
                          "prepend-icon": "ui-icon-circle-account",
                          "qa-locator": "appointment_selected_patient_card",
                          "card-class": "py-2",
                          "min-height": "56",
                          "is-error-state": _vm.isErrorState,
                          "is-flat": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.isSelectedPatient
                              ? {
                                  key: "icon",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass:
                                                "ui-icon-pen cursor-pointer ml-4",
                                            },
                                            "div",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                      },
                      "AppointmentDataCard",
                      _vm.selectedPatientCardProps,
                      false
                    ),
                    [
                      _vm._v(" "),
                      _c(
                        VBtn,
                        _vm._g(
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isSelectedPatient,
                                  expression: "!isSelectedPatient",
                                },
                              ],
                              staticClass: "mb-2",
                              attrs: {
                                color: "bg-primary",
                                block: "",
                                depressed: "",
                              },
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c("span", { staticClass: "primary--text" }, [
                            _vm._v(
                              _vm._s(_vm.$t("Выбрать пациента", _vm.options))
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isTelemedMedical
                    ? _c(VExpandTransition, [
                        _vm.isUnderagePatient
                          ? _c(
                              "div",
                              [
                                _c(
                                  "BannerInfo",
                                  {
                                    staticClass: "text--text mt-1",
                                    attrs: {
                                      "inner-atom-indent": 0,
                                      "text-outer-atom-indent": 2,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "text-body-1" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "Пациента до 18 лет должен сопровождать взрослый с комплектом документов",
                                              _vm.options
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "link-decoration-underline text-body-1 primary--text mt-2",
                                        on: {
                                          click: function ($event) {
                                            _vm.isDocumentsInfoModalVisible = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "Какие документы нужны",
                                                _vm.options
                                              )
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("AppointmentDocumentsInfoModal", {
                                  model: {
                                    value: _vm.isDocumentsInfoModalVisible,
                                    callback: function ($$v) {
                                      _vm.isDocumentsInfoModalVisible = $$v
                                    },
                                    expression: "isDocumentsInfoModalVisible",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(VExpandTransition, [
                    _vm.isSelectedPatient && !_vm.isValidBirthDay
                      ? _c(
                          "div",
                          [
                            _c("BaseAlert", {
                              staticClass: "mt-2",
                              attrs: {
                                "data-qa": "appointment_patient_card_alert",
                                color: "text-error",
                                text: _vm.invalidBirthDayText,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.isVisibleModal,
        callback: function ($$v) {
          _vm.isVisibleModal = $$v
        },
        expression: "isVisibleModal",
      },
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "modalContent",
          staticClass: "h-100 overflow-y-auto",
          class: { "modal-content-desktop": !_vm.isMobile },
        },
        [
          _c(
            VStepper,
            {
              model: {
                value: _vm.currentStep,
                callback: function ($$v) {
                  _vm.currentStep = $$v
                },
                expression: "currentStep",
              },
            },
            [
              _c(
                VStepperItems,
                [
                  _c(
                    VStepperContent,
                    { attrs: { step: "1" } },
                    [
                      _c("AppointmentPatientList", {
                        class: { "py-4": !_vm.isAnyTelemed },
                        on: {
                          "appointment-patient-list:click-invalid":
                            _vm.handleClickInvalidPatient,
                          "appointment-patient-list:click-valid":
                            _vm.handleClickValidPatient,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    VStepperContent,
                    { attrs: { step: "2" } },
                    [
                      _c("AppointmentPatientForm", {
                        staticClass: "py-4",
                        class: _vm.isMobile ? "px-2" : "px-6",
                        attrs: {
                          "init-patient": _vm.initPatient,
                          "disabled-fields": _vm.disabledPatientFormFields,
                        },
                        on: {
                          "appointment-patient-form:save":
                            _vm.handleSavePatient,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }